var logo = $('.logo');
var content = $('#content > .container-fluid');
var sidebar = $('.nav-main-container');

$(document).ready(function(){
	positionLogo();

	$(window).on('resize', function() {
		positionLogo();
	});
});

function positionLogo() {
	logo.css('left', (sidebar.width() + (content.offset().left-sidebar.width())/2) - logo.width()/2)
}


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/header/logo.js
 **/